module.exports = __webpack_public_path__ + "static/media/notification.454ccbc4.svg";